<script>
import {
    eventGroupState,
    isSelectedEventGroupLocked,
} from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { commitHistory } from "@app/store/historyStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

/** @type {{ row: any, column: any, api?: any }} */
let { row } = $props();

let current = $derived(normalizeAlignment(row?.alignment));

/**
 * @param {string | undefined | null} value
 */
function normalizeAlignment(value) {
    if (value === "right") return "right";
    if (value === "center") return "center";
    return "left";
}

/**
 * @param {"left" | "center" | "right"} alignment
 */
function setAlignment(alignment) {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    const egIdx = projectState.selected;
    const eventId = row?.id;
    if (eventId == null || egIdx == null) return;

    const xPos =
        alignment === "left" ? "start" : alignment === "right" ? "end" : "center";

    commitHistory({
        name: `align ${alignment}`,
        eventGroup: egIdx,
        mutate: {
            eventGroupState: (draft) => {
                const idx = draft[egIdx].events.findIndex((e) => e.id === eventId);
                if (idx < 0) return;
                draft[egIdx].events[idx].alignment =
                    alignment === "left" ? "" : alignment;
                draft[egIdx].events[idx].xPos = xPos;
                if (!draft[egIdx].selected.includes(idx)) {
                    draft[egIdx].selected = [idx];
                }
            },
        },
    });

    // Keep toolbar Quill in sync when the active event is edited
    if (
        window.quillEditor &&
        eventGroupState[egIdx]?.selected?.[0] != null &&
        eventGroupState[egIdx].events[eventGroupState[egIdx].selected[0]]?.id ===
            eventId
    ) {
        window.quillEditor.formatLine(
            0,
            9999,
            "align",
            alignment === "left" ? "" : alignment,
            "silent",
        );
    }
}
</script>

<div class="lcr-cell" role="group" aria-label={m.editor_table_column_align()}>
    <button
        type="button"
        class="lcr-btn"
        class:active={current === "left"}
        title="Left"
        onclick={(e) => {
            e.stopPropagation();
            setAlignment("left");
        }}>L</button>
    <button
        type="button"
        class="lcr-btn"
        class:active={current === "center"}
        title="Center"
        onclick={(e) => {
            e.stopPropagation();
            setAlignment("center");
        }}>C</button>
    <button
        type="button"
        class="lcr-btn"
        class:active={current === "right"}
        title="Right"
        onclick={(e) => {
            e.stopPropagation();
            setAlignment("right");
        }}>R</button>
</div>

<style>
.lcr-cell {
    display: inline-flex;
    gap: 2px;
    align-items: center;
    height: 100%;
}
.lcr-btn {
    border: 1px solid transparent;
    background: transparent;
    color: inherit;
    font-size: 0.7rem;
    font-weight: 600;
    line-height: 1;
    padding: 0.15rem 0.35rem;
    border-radius: 0.25rem;
    cursor: pointer;
    min-width: 1.4rem;
}
.lcr-btn:hover {
    background: rgba(13, 110, 253, 0.15);
}
.lcr-btn.active {
    background: #0d6efd;
    color: #fff;
}
</style>
